"use client";

import { Product } from "@nusrif/types";
import { Share2 } from "lucide-react";

interface ShareButtonProps {
    product: Product;
}

export const ShareButton = ({ product }: ShareButtonProps) => {
  const handleShare = () => {
    // use the share api to share the current url
    if (navigator.share) {
      navigator.share({
        title: product.name,
        url: window.location.href,
      });
    }
  };
  return (
    <div className="relative w-10 h-10 rounded-full flex items-center justify-center">
      <button onClick={() => handleShare()}>
        <Share2 className="w-5 h-5 text-primary" />
      </button>
    </div>
  );
};
